import { Avatar, Tooltip } from 'antd'
import { User } from 'iconsax-react'

export interface ProfileItemProps {
  email: string
  username?: string
  first_name?: string
  last_name?: string
}

interface Props {
  item: ProfileItemProps
}

export const ProfileItem = ({ item }: Props) => {
  return (
    <Tooltip placement="bottomRight" title={item.email}>
      <Avatar className="pointer" icon={<User size="16" />}>
        {item.username
          ? item.username
          : `${item.first_name?.charAt(0) || ''}${
              item.last_name?.charAt(0) || ''
            }`}
      </Avatar>
    </Tooltip>
  )
}
